export function formatDateTimeUnit(unit: number): string {
  return ('0' + unit).slice(-2);
}
